import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { VERIFY_AND_SENT_OTP, VERIFY_AND_SENT_OTP_SUCCESS, VERIFY_AND_SENT_OTP_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* VerifyAndSentOtp({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/profile/verify-and-send-otp`,
      method: 'POST',
      data: payload.data,
      // isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: VERIFY_AND_SENT_OTP_SUCCESS,
        payload: response?.data,
      });
    } else if(response.status === 202){
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: VERIFY_AND_SENT_OTP_SUCCESS,
        payload: response?.data,
      });
    }
    else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: VERIFY_AND_SENT_OTP_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: VERIFY_AND_SENT_OTP_ERROR, payload: error });
  }
}

export function* watchVerifyAndSentOtp() {
  yield takeEvery(VERIFY_AND_SENT_OTP, VerifyAndSentOtp);
}

function* VerifyAndSentOtpSaga() {
  yield all([fork(watchVerifyAndSentOtp)]);
}

export default VerifyAndSentOtpSaga;
